import { useNavigate } from 'react-router-dom';
import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import SafeHtml from 'shared/SafeHtml';

import { PathName } from 'router/paths';
import { parseText } from 'utils/parseText';

import { DefaultMessageProps } from './defaultMessage.types';

const DefaultMessage: React.FC<DefaultMessageProps> = ({ combined, message, self }) => {
  const navigate = useNavigate();
  const formattedMessage = parseText(message?.message, { markdown: !!message.renderMarkdown });

  return (
    <>
      {(message.message || message.isLoadingMessage || !!message.buttons.length) && (
        <div
          className={classNames(
            'w-fit rounded-xl px-5 py-3',
            self ? 'ml-6 bg-secondary-100' : 'mr-6 bg-gray-100',
            !combined && (self ? 'rounded-br-none' : 'rounded-bl-none')
          )}
        >
          {message.isLoadingMessage ? (
            <div
              aria-label="Assistant is typing"
              className="flex items-center gap-1.5 text-gray-500"
              role="status"
            >
              {[0, 1, 2].map((index) => (
                <span
                  className="size-2 animate-bounce rounded-full bg-current"
                  key={index}
                  style={{ animationDelay: `${index * 150}ms` }}
                />
              ))}
            </div>
          ) : (
            <div
              className={classNames('break-word break-words whitespace-normal text-gray-700', {
                '[&>*+*]:mt-3 [&_li+li]:mt-1 [&_p]:leading-6': message.renderMarkdown,
                'whitespace-pre-line': !message.renderMarkdown
              })}
            >
              <SafeHtml html={formattedMessage} />
            </div>
          )}
          {message.buttons.map(({ label }, index) => (
            <Common.Button
              className="mt-4"
              color="blue"
              key={index.toString()}
              preIcon="lifemd-reversed"
              style="pill"
              onClick={() => navigate(PathName.CreateAppointment)}
            >
              {label}
            </Common.Button>
          ))}
        </div>
      )}
    </>
  );
};

export default DefaultMessage;
